import AIIcon from "../images/categoryIcons/AI.png";
import CloudIcon from "../images/categoryIcons/Cloud.png";
import ESGIcon from "../images/categoryIcons/ESG.png";
import SecurityIcon from "../images/categoryIcons/Security.png";
import TestAutomationIcon from "../images/categoryIcons/TestAutomation.png";
import { isInt } from "./helpers";

export const sections = {
  SECURITY: "Security",
  CLOUD: "Cloud",
  ESG: "ESG",
  AI: "AI",
  TEST_AUTOMATION: "Test Automation",
};

export const languages = {
  DE: "DE",
  EN: "EN",
  FR: "FR",
};

export const languageKey = {
  DE: "german",
  EN: "english",
  FR: "french",
};

export const versions = {
  STANDARD: "Standard",
  TWO_DIMENSIONAL: "Two-Dimensional",
};

export const sectionData = {
  [sections.SECURITY]: {
    name: sections.SECURITY,
    icon: SecurityIcon,
  },
  [sections.CLOUD]: {
    name: sections.CLOUD,
    icon: CloudIcon,
  },
  [sections.ESG]: {
    name: sections.ESG,
    icon: ESGIcon,
  },
  [sections.AI]: {
    name: sections.AI,
    icon: AIIcon,
  },
  [sections.TEST_AUTOMATION]: {
    name: sections.TEST_AUTOMATION,
    icon: TestAutomationIcon,
  },
};

export const industries = {
  KLINIKEN: "Kliniken",
  WASSER: "Wasser",
  ERNAEHRUNG: "Ernährung",
  ENERGIE: "Energie",
  TELEKOMMUNIKATION: "Telekommunikation",
  LOGISTIK: "Logistik",
  FINANZ: "Finanzwesen",
  MANUFACTORING: "Manufacturing",
  RETAIL: "Retail",
  PHARMA: "Pharma",
  DIAKONIEN: "Diakonien",
};

export const congnitoGroups = {
  ADMIN: "Admin",
  CONTRIBUTOR: "Contributor",
  USER: "User",
};

export const packages = {
  BASIC: "Basic",
  PREMIUM: "Premium",
};

export const assessmentValue = {
  TRIAL: "Trial",
  NO_TRIAL: "No Trial",
};

export const assessmentState = {
  NEW: "New",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
};

export const ALLE_INDUSTRIEN_ID = "02b33c02-0b5a-47a1-a0cc-bda0d6c9642d";

export const COMPASS_GRADIENT = "linear-gradient(to right, #138656, #333333)";
export const CGI_GRADIENT_A =
  "linear-gradient(to right,  #E31937, #A82465 60%, #5236AB)";
export const CGI_GRADIENT_A_TO_TOP =
  "linear-gradient(to top, #E31937, #A82465 60%, #5236AB)";
export const CGI_GRADIENT_A_45DEG =
  "linear-gradient(45deg, #E31937, #A82465 60%, #5236AB)";
export const CGI_GRADIENT_B =
  "linear-gradient(to right,  #991F3D, #E31937 33%, #FF6A00 66%, #FFCDD2)";
export const CGI_GRADIENT_B_45DEG =
  "linear-gradient(45deg,  #991F3D, #E31937 33%, #FF6A00 66%, #FFCDD2)";
export const CGI_RED = "#E31937";
export const CGI_BLACK = "#000000";
export const CGI_WHITE = "#FFFFFF";
export const CGI_PURPLE = "#5236AB";
export const CGI_SUCCESS = "#128354";
export const CGI_WARNING = "#f1a425";
export const CGI_ERROR = "#b00020";
export const CGI_GREY = "#333333";

export const nullIdStandard = "00000000-0000-0000-0000-000000000000";
export const nullIdTwoDim = "00000000-0000-0000-0000-000000000001";

export const nullIdMapping = {
  [versions.STANDARD]: nullIdStandard,
  [versions.TWO_DIMENSIONAL]: nullIdTwoDim,
};

export const discreteDescriptions = {
  0: "notFulfilled",
  1: "barelyFulfilled",
  2: "largelyFulfilled",
  3: "fulfilled",
};

export function returnColor(disabled, selectedLevel, maxLevel, fulfilled) {
  if (disabled) return CGI_RED;

  if (!maxLevel || maxLevel <= 0) {
    return fulfilled ? CGI_SUCCESS : CGI_ERROR;
  }

  const upperThirdThreshold = Math.ceil((maxLevel / 3) * 2);
  if (selectedLevel >= upperThirdThreshold) return CGI_SUCCESS;

  return CGI_ERROR;
}

export const solutionKeys = {
  0: "solution",
  1: "solution1",
  2: "solution2",
  3: "solution3",
};
